import React from "react";
import styles from "./DefaultHero.module.scss";
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';

import GameList from "constants/GameList";

import ScrawlHero from "images/heros/scrawl.jpg";
import DrawWithHero from "images/heros/draw-with-dave.jpg";
import ColourBrainHero from "images/heros/colour-brain.jpg";
import ChameleonHero from "images/heros/the-chameleon.jpg";
import CanOfSquirmsHero from "images/heros/can-of-squirms.jpg";
import HerdMentalityHero from "images/heros/herd-mentality.jpg";
import UniChalHero from "images/heros/hero-unichal-new.jpg";
import MoosicMooviesHero from "images/heros/moosic-moovies.jpg";
import CatchphraseHero from "images/heros/hero-catchphrase-new.jpg";
import DONDHero from "images/heros/hero-dond-new.jpg";
import PokerHero from "images/heros/poker.jpg";
import MDMDHero from "images/heros/hero-mdmd.jpg";
import TheChaseHero from "images/heros/hero-thechase.jpg";

import FreePlayImg from "images/FreePlayWeekend.png";
import NewGameImg from "images/NewGameImg.png";
import NewAddonImg from "images/NewAddonImg.png";

const heroImages = [
    //ScrawlHero,
    //DrawWithHero,
    //ColourBrainHero,
    //ChameleonHero,
    //CanOfSquirmsHero,
    //HerdMentalityHero,

    { src: MDMDHero, gameId: "mdmd" },
    { src: DONDHero, gameId: "dond" },
    { src: CatchphraseHero, gameId: "catchphrase" },
    { src: UniChalHero, gameId: "universally_challenged", moveLeft: true, },

    //{ src: PokerHero, gameId: "poker" },

    //MoosicMooviesHero,
];


const DefaultHero = () => {
    const navigate = useNavigate();

    const isFreePlay = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date('2024-10-24T00:00:00');
        const endDate = new Date('2024-10-27T23:59:59');

        if (today >= startDate && today <= endDate) {
            return true;
        } else {
            return false;

        }
    }

    const isNewGamePeriod = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date('2025-04-07T18:00:00');
        const endDate = new Date('2025-04-09T23:59:59');

        if (today >= startDate && today <= endDate) {
            return true;
        } else {
            return false;
        }
    }

    const isMobileWidth = () => {
        return window.innerWidth < 500;
    }

    return (
        <section className={`${styles.heroBackground}`}>
            <div className={styles.vignette} />
            <h2 className="text-center">Party games to play on your TV</h2>
            {
                <Carousel className={styles.hero}
                    controls={false}
                    indicators={false}
                    fade
                >
                    {
                        heroImages.map((h, i) => {

                            let game = GameList.find(g => g.gameId === h.gameId);

                            return <Carousel.Item key={`carousel-item-${i}`} className={styles.carouselItem}>
                                <img src={h.src} alt="" className={`${styles.carouselImage} ${(h.moveLeft && isMobileWidth()) && styles.left}`} />
                                <div className={styles.overlay}></div>
                                {/*<img src={game.logo} alt="" className={styles.carouselLogo} />*/}
                            </Carousel.Item>
                        })
                    }
                </Carousel>
            }

            {
                isFreePlay() &&
                <img src={FreePlayImg} className={styles.freePlayImg} />
            }
            {
                isNewGamePeriod() &&
                <img src={NewAddonImg} className={styles.freePlayImg} />
            }
        </section>
    );
};

export default DefaultHero;